import * as http from '@/api/config';


/* 获取系统信息 */
export function setRouletteTools(data) {
    const url = 'tools';
    return http.$post(url, data);
}

export function startRoulette() {
    const url = 'start';
    return http.$get(url);
}

export function stopRoulette() {
    const url = 'stop';
    return http.$get(url);
}

export function getRouletteInfo() {
    const url = 'info';
    return http.$get(url);
}


// WEBPACK FOOTER //
// ./src/api/module/game.js